export const SET_META = 'SET_META';

export const actionSetMeta = meta => ({
    type: SET_META,
    payload: meta
})